import React, { useState, useEffect, useRef } from "react";
import { Grid, Button, Box } from "@material-ui/core";

import "./style.css";

import getParameterByName from "../../../../Functions/functions";
import axios from "axios";

import Handsontable from "handsontable";
import "handsontable/dist/handsontable.full.min.css";
import { HotTable } from "@handsontable/react";
import { registerAllModules } from "handsontable/registry";
import { parseDDMMYYYY } from "../../../../Functions/dateParsingFunction";

registerAllModules();

class CalendarOnlyDateEditor extends Handsontable.editors.DateEditor {
  open() {
    super.open();
    if (this.TEXTAREA) {
      this.TEXTAREA.readOnly = true;
    }
  }
}
Handsontable.editors.registerEditor('calendarOnlyDate', CalendarOnlyDateEditor);

const FCA_Details_Table = ({ formState, setFormState, show, reviwerFlag, role }) => {
  const tableData = {
    rowId: "",
    accountId: 0,
    invoice_Id: Number(formState.invoice_Id), // number for departCord
    glAccount: undefined,
    accountType: "Debit",
    costCenter: "",
    costCenterOwner: "",
    costCenterOwnerName: "",
    wbsElement: "",
    horizonId: "",
    vendor_Code: "",
    amount: 0,
    profitCenter: "",
    department: "",
    description: `${formState.invoice_Desc}`,
  };

  const invoiceId = getParameterByName("invoiceId");


  const addInput = () => {
    const num = Math.random();
    tableData.rowId = num;
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: [...formState.invoice_Accounts_list, tableData],
    }));
  };

  const hotRef = useRef(null);
  const [columns, setColumns] = useState([]);

  const columnHeaders = [
    "Last Rent/Month",
    "New Rent/Month",
    "Increase/Decrease",
    "From",
    "To",
    "New Rent Period",
    "New Rent Amount",
   
  ];

  const [fcaTableData, setFcaTableData] = useState([
  {
    lastRent: 0,
    newRent: 0,
    increase: "",      // calculated
    from: "",
    to: "",
    period: "",        // calculated
    newRentAmount: "", // calculated
  },
]);


const fcaTableColumns = [
  { data: "lastRent", type: "numeric" , numericFormat: {
    pattern: "0,0",  // ✅ Adds comma separators
    culture: "en-GB" // ✅ Apply locale
  } },
  { data: "newRent", type: "numeric" , numericFormat: {
    pattern: "0,0",  // ✅ Adds comma separators
    culture: "en-GB" // ✅ Apply locale
  } },
  { data: "increase", type: "text", readOnly: true },
  { data: "from", type: "date", dateFormat: "DD-MMM-YYYY", editor: "calendarOnlyDate" },
  { data: "to", type: "date" , dateFormat: "DD-MMM-YYYY", editor: "calendarOnlyDate" },
  { data: "period", type: "numeric", readOnly: true },
  { data: "newRentAmount", type: "numeric", readOnly: true , numericFormat: {
    pattern: "0,0",  // ✅ Adds comma separators
    culture: "en-GB" // ✅ Apply locale
  } },
];


  const adjustAmountOnGLTable = (tempArr) => {
    let newAmount = Number(formState?.invoice_Amount);
    if (tempArr.length > 0) {
      for (let i = 0; i < tempArr.length; i++) {
        const item = tempArr[i];
        // if (index === 0 && item.amount == 0) {
        newAmount = newAmount - Number(item.amount);
        // }
      }
    }
    return newAmount;
  };

const handleAfterChange = (changes, source) => {
  if (!changes || source === "loadData") return;

  const newData = [...fcaTableData];
  let hasUpdate = false;

  changes.forEach(([rowIndex, prop, oldVal, newVal]) => {
    const row = newData[rowIndex];

    // 1️⃣ Calculate % Increase or Decrease
    const last = parseFloat(row.lastRent) || 0;
    const current = parseFloat(row.newRent) || 0;
    if ((prop === "lastRent" || prop === "newRent") && !isNaN(last) && last !== 0 && !isNaN(current)) {
      const diff = current - last;
      const percent = Math.abs((diff / last) * 100).toFixed(2);
      row.increase = diff > 0 ? `${percent}% ↑` : diff < 0 ? `${percent}% ↓` : "0%";
      hasUpdate = true;
    }

    // 2️⃣ Calculate New Rent Period (Months)
if (prop === "from" || prop === "to") {
  const fromDate = new Date(row.from);
  const toDate = new Date(row.to);

  if (!isNaN(fromDate) && !isNaN(toDate) && toDate >= fromDate) {
    const start = new Date(fromDate);
    const end = new Date(toDate);

    // If both dates in the same month -> single partial (exclude start day)
    if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
      const daysInMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
      const daysUsed = end.getDate() - start.getDate() + 1; // exclude start day
      row.period = parseFloat((daysUsed / daysInMonth).toFixed(12));
      hasUpdate = true;
      return;
    }

    // Start partial (exclude start day)
    const daysInStartMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
    const startMonthDaysUsed = daysInStartMonth - start.getDate() + 1; // exclude start day
    const startFraction = startMonthDaysUsed / daysInStartMonth;

    // Middle full months
    let middleStart = new Date(start.getFullYear(), start.getMonth() + 1, 1);
    let middleMonths = 0;
    while (
      middleStart.getFullYear() < end.getFullYear() ||
      (middleStart.getFullYear() === end.getFullYear() &&
        middleStart.getMonth() < end.getMonth())
    ) {
      middleMonths += 1;
      middleStart.setMonth(middleStart.getMonth() + 1);
    }

    // End partial (include end day)
    const daysInEndMonth = new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate();
    const endMonthDaysUsed = end.getDate(); // include end day
    const endFraction = endMonthDaysUsed / daysInEndMonth;

    const total = startFraction + middleMonths + endFraction;
    row.period = parseFloat(total.toFixed(4)); // keep high precision; format later if needed
    hasUpdate = true;
  }
}


    // 3️⃣ Calculate New Rent Amount
    if (
      (prop === "newRent" || prop === "from" || prop === "to") &&
      !isNaN(row.newRent) &&
      !isNaN(row.period)
    ) {
      row.newRentAmount = Math.round(row.newRent * row.period);
      hasUpdate = true;
    }

    if(prop === "lastRent"){
      hasUpdate = true;
    }
  });

  if (hasUpdate) {
    setFcaTableData(newData);
  }
};
 
  const handleBeforeChange = (changes, source) => {
    if (source == "CopyPaste.paste" && changes[0][1] == 1)
      changes[0][3] = changes[0][3] = changes[0][3].replaceAll(",", "").trim();
  };

  const handleBeforeRemoveRow = (a, b, c, d, e, f) => {
    let tempArr = formState.invoice_Accounts_list;
    for (let index = 0; index < c.length; index++) {
      const rowIndex = c[index];
      const rowId = formState.invoice_Accounts_list[rowIndex].rowId;
      tempArr = tempArr.filter((x) => x.rowId !== rowId);
    }
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: tempArr,
    }));
  };

  useEffect(() => {
    const data = [
      {
        data: "glAccount",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetChargeAccount_v1/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.GLAccount + " - " + m.ShortText;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "amount",
        width: 200,
        type: "numeric",
        numericFormat: {
          pattern: "0,0.00",
          culture: "en-US", // this is the default culture, set up for USD
        },
      },
      {
        data: "costCenter",
        type: "autocomplete",
        source: function (query, proces) {
          var data = { query: query };
          let _ca = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _ca = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetCostCenters_v1/${_ca ? _ca : "-1"}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.CostCenterCode + " - " + m.Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 180,
      },
      {
        data: "costCenterOwner",
        width: 70,
        type: "text",
        readOnly: true,
      },
      {
        data: "costCenterOwnerName",
        width: 240,
        type: "text",
        readOnly: true,
      },

      {
        data: "profitCenter",
        width: 110,
        type: "text",
      },
      {
        data: "wbsElement",
        width: 130,
        type: "text",
      },
      {
        data: "description",
        width: 190,
        type: "text",
      },
    ];

   
    const cols = data;
    setColumns(cols);
  }, [formState.invoice_Accounts_list, formState.invoiceCategory]);


useEffect(() => {
  if (
  Array.isArray(fcaTableData) &&
  fcaTableData.length > 0 &&
  JSON.stringify(fcaTableData) !== JSON.stringify([
    {
      lastRent: 0,
      newRent: 0,
      increase: "",
      from: "",
      to: "",
      period: "",
      newRentAmount: "",
    },
  ])
) {
    const fcaUpdateData = [...formState?.FCA_Details];


    const newEntry = {
      ...fcaTableData[0],
    };

    const isSame =
      JSON.stringify(fcaUpdateData[0]) === JSON.stringify(newEntry);

    if (!isSame) {
      fcaUpdateData[0] = newEntry;
      setFormState((prev) => ({
        ...prev,
        FCA_Details: fcaUpdateData,
      }));
    }
  }
}, [fcaTableData]);


useEffect(() => {
  if (Array.isArray(formState?.FCA_Details) && formState.FCA_Details.length > 0) {
    
    const newFCADetails = [...formState.FCA_Details];
    
    const mapped = newFCADetails.map(item => ({
      lastRent: Number(item.lastRent || item.LastRent) || 0,
      newRent: Number(item.newRent || item.NewRent) || 0,
      increase: item.Increase || item.increase || "",
      from: item.From || item.from || "",
      to: item.To || item.to || "",
      period: Number(item.Period || item.period) || 0,
      newRentAmount: item.NewRentAmount || item.newRentAmount || 0,
    }));

    const isSame = JSON.stringify(fcaTableData) === JSON.stringify(mapped);

    
    if (!isSame) {
      setFcaTableData(mapped);
    }
  }
}, [formState?.FCA_Details]);

  return (
    <Grid container>
      <Grid
  item
  xs={12}
  sm={12}
  md={12}
  lg={12}
  style={{ width: "100%", zIndex: "0" }} // ← FIXED!
>

        {/* <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
             <LinearProgress color="info" />
             <LinearProgress color="info" />
             <LinearProgress color="info" />
  </Stack> */}
        <HotTable
          data={fcaTableData}
          colHeaders={
       columnHeaders
          }
          columns={fcaTableColumns}
           cells={(row, col) => {
            const cellProperties = {};
            if (fcaTableColumns[col]?.readOnly) {
              const column = fcaTableColumns[col];
              
              if (column.type === "numeric") {
                // Use numeric renderer with formatting
                cellProperties.renderer = (instance, td, row, col, prop, value, cellProperties) => {
                  // Apply numeric rendering first
                  Handsontable.renderers.NumericRenderer.call(
                    this,
                    instance,
                    td,
                    row,
                    col,
                    prop,
                    value,
                    cellProperties
                  );
                  // Then apply grey background
                  td.style.background = "#f0f0f0";
                  td.style.color = "#000";
                };
              } else {
                cellProperties.renderer = (instance, td, row, col, prop, value, cellProperties) => {
                  Handsontable.renderers.TextRenderer.call(
                    this,
                    instance,
                    td,
                    row,
                    col,
                    prop,
                    value,
                    cellProperties
                  );
                  td.style.background = "#f0f0f0";
                  td.style.color = "#000";
                };
              }
            }
            return cellProperties;
          }}
          manualRowResize={true}
          manualColumnResize={true}
          rowHeaders={true}
          height="120"
          rowHeaderWidth={25}
          contextMenu={true}
          filters={true}
          width="100%"
        stretchH="all"
          readOnly={reviwerFlag}
          dropdownMenu={true}
          ref={hotRef}
          beforeChange={handleBeforeChange}
          beforeRemoveRow={handleBeforeRemoveRow}
          afterChange={handleAfterChange}
          licenseKey="non-commercial-and-evaluation" // for non-commercial use
        />
       
      </Grid>
    </Grid>
  );
};

export default React.memo(FCA_Details_Table);
